import { useEffect } from "react"
import { ICardFieldProps } from "../cards/CardField"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import StatisticLineCardField from "./StatisticLineCardField"
import { ISliderItem } from "src/modules/pe-landing-module/data/interfaces"

/* Protopia Ecosystem component */ 
const CardFieldStatisticLine = (props: ICardFieldProps): JSX.Element => {
    const { value, field, section, i } = props
        useEffect(() => { 
                addCSSClass(
                    `landing-card-field-statistic-line-${section.id + "-" + value?.id}`,
                    `.landing-card-field-statistic-line-${section.id + "-" + value?.id} {
                        
                    } 
                    `
                )
                return () => removeCSSClass(`landing-card-field-statistic-line-${section.id + "-" + value?.id}`)
            }, []) 
        
    const style = { 
        ...field.style, 
        ...value.style 
    }    
    style.backgroundColor = undefined    
    return <div 
        className={`landing-card-field landing-card-field-statistic-line landing-card-field-statistic-line-${section.id + "-" + value.id} ${value.className}`}  
        style={style}
        data-card-field-id={i} 
        card-field-section-id={section.id}
    >
        {
            Array.isArray(field.items) &&
            field.items
                .map( (tag: any, i: number) => {
                    const item: ISliderItem = {
                        ...tag,
                        value: Array.isArray( value.data ) ?  value.data[i] : 0
                    }
                    return <StatisticLineCardField key={i} item={item} field={field} /> 
                })
        } 
    </div>
}
export default CardFieldStatisticLine